import { Component, OnDestroy, OnInit } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { ManagmentCardComponent } from '../managment-card/managment-card.component';

@Component({
    selector: 'app-rapports',
    imports: [
    TranslateModule,
    MatIconModule,
    RouterOutlet,
    ManagmentCardComponent
],
    templateUrl: './rapports.component.html',
    styleUrl: './rapports.component.scss'
})
export class RapportsComponent implements OnInit, OnDestroy {
  showMenu = true;
  private _routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.checkRoute(this.router.url);
    this._routerSub = this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => this.checkRoute(e.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this._routerSub?.unsubscribe();
  }

  goBack(): void {
    this.router.navigate(['/rapports']);
  }

  private checkRoute(url: string): void {
    const cleanUrl = url.split('?')[0];
    this.showMenu = cleanUrl === '/rapports' || cleanUrl === '/rapports/';
  }
}
